<template>
  <div class="v-uploadTicket">
    <div class="list" @click="onScan">
      <div class="imageBox">
        <img src="@/assets/images/QRcodeIcon.png" alt="" class="QRcodeIcon" />
      </div>
      <div class="tips">
        <div class="title">扫一扫</div>
        <div class="text">通过扫描二维码上传进项发票</div>
      </div>
      <img src="@/assets/images/QRcode.png" alt="" class="QRcode" />
    </div>
    <div class="list manualEntry" @click="onManualEntry">
      <div class="imageBox">
        <img src="@/assets/images/writeIcon.png" alt="" class="QRcodeIcon" />
      </div>
      <div class="tips">
        <div class="title">手工录入</div>
        <div class="text">通过手工录入上传进项发票</div>
      </div>
      <img src="@/assets/images/write.png" alt="" class="QRcode" />
    </div>
  </div>
</template>
<script>
import { scanCode, wxConfig } from '@/utils/invoiceCheck';
import { Toast } from 'vant';

export default {
  data() {
    return {};
  },
  created() {
    wxConfig();
  },
  computed: {},
  methods: {
    onManualEntry() {
      this.$router.push({
        path: '/supermarket/v2/manualEntry',
        query: { type: 2 },
      });
    },
    onScan() {
      scanCode();
    },
    checkInvoice(data) {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$api.PublicPage.checkAmount({ invoice: data }).then((res) => {
        console.log(res, '==res');
        if (res.code === '200' && res.success) {
          this.$router.push({
            path: '/supermarket/v2/upoladSuccess',
            query: {
              type: this.$route.query.type,
              data: JSON.stringify(res.data),
            },
          });
        } else {
          this.$router.push({
            path: '/supermarket/v2/upoladFail',
            query: {
              type: this.$route.query.type,
            },
          });
        }
      }).finally(() => {
        this.$toast.clear();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.v-uploadTicket {
  width: 100%;
  height: 100%;
  .list {
    background-image: linear-gradient(90deg, #fca825 0%, #f76f10 100%);
    box-shadow: 0 4px 12px 0 rgba(0, 31, 51, 0.08);
    border-radius: 4px;
    height: 80px;
    margin: 16px;
    display: flex;
    align-items: center;
    position: relative;
    .imageBox {
      width: 48px;
      height: 48px;
      opacity: 0.8;
      background: #ffffff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 16px;
      margin-right: 16px;
      .QRcodeIcon {
        width: 24px;
        height: 24px;
      }
    }
    .tips {
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #ffffff;
        line-height: 24px;
        font-weight: 600;
        text-align: left;
      }
      .text {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #ffffff;
        line-height: 18px;
        font-weight: 400;
        margin-top: 4px;
      }
    }
    .QRcode {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 78px;
      height: 62px;
    }
  }
  .manualEntry {
    background-image: linear-gradient(90deg, #4ed988 0%, #28b964 100%);
  }
}
</style>
